export default __webpack_public_path__ + "static/area-with-negative-values-0fd67e3e7b807648054b4c6373c27f98.png";